import styled from 'styled-components'
import theme from '~/design'

const Avatar = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50px;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.lightText};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    width: 44px;
    height: 44px;
  }
`
const Header = styled.header`
  display: flex;
  align-items: center;
  gap: 10px;
`

const UserInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 150px;

  .name,
  .email {
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .name {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${theme.colors.darkText};
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      font-size: 14px;
    }
  }
  .email {
    margin: 0;
    font-size: 1rem;
    color: ${theme.colors.mediumGrey};
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
      font-size: 14px;
    }
  }
`

interface UserInformationProps {
  displayName?: string
  email?: string | null
}

const AvatarHeader = ({ displayName, email }: UserInformationProps) => {
  return (
    <Header>
      <Avatar>{displayName?.[0]?.toUpperCase() || email?.[0]?.toUpperCase()}</Avatar>
      <UserInformation>
        <p className='name'>{displayName || email}</p>
        <p className='email'>{email}</p>
      </UserInformation>
    </Header>
  )
}

export default AvatarHeader
